











import {Component, Prop, Vue} from 'vue-property-decorator'

interface Button {
  title: string,
  value: any
}

@Component({
  components: {},
})
export default class ToggleSwitch extends Vue {
  @Prop(Array) public buttons?: Button[]
  @Prop() public selected: any

  public onClick(item: Button, idx: number) {
    // this.selected = idx
    this.$emit('update:selected', item.value)
  }
}
